module.exports = __webpack_public_path__ + "img/p12.977396f0.png";